/* eslint-disable no-shadow */
import Vue from 'vue'
import { sharedCartMethods } from '../../commonJs/sharedCartMethods'
import router from '../../router/index'
import { store } from '../store'
import { orderApi } from '../../services/ApiServices/orderApi'

const state = {
	mainCart: {
		cartProducts: [],
		cartTotal: 0,
		cartCount: 0,
		cartItemTotal: 0,
		cartTotalOffer: 0
	},
	localCart: {
		cartProducts: []
	},
	confirmedProducts: []
}

export function updateCartproperties (state, cartToUpdate) {
	let total = 0
	let itemTotal = 0
	let cartOffers = 0
	const productsInCart = state[cartToUpdate].cartProducts
	productsInCart.forEach((cartProducts) => {
		if (cartProducts.price) {
			if (cartProducts.promotion_applied_price) {
				total += cartProducts.quantity * cartProducts.promotion_applied_price
				itemTotal += cartProducts.quantity * cartProducts.promotion_applied_price
				cartOffers += cartProducts.quantity *
					(cartProducts.price - cartProducts.promotion_applied_price)
			} else {
				total += cartProducts.quantity * cartProducts.price
				itemTotal += cartProducts.quantity * cartProducts.price
			}
		}
	})
	if (store.state.user.giftCardAmount && store.state.user.giftCardAmount.subtotal) {
		total -= store.state.user.giftCardAmount.subtotal
	}
	if (store.state.user.coinRedeemValue && store.state.user.coinRedeemValue.coinValue) {
		total -= store.state.user.coinRedeemValue.coinValue
	}
	total += store.getters['charges/getShippingCharge'] * state[cartToUpdate].cartCount + store.getters['charges/getTaxCharge'] * state[cartToUpdate].cartCount
	// Vue.nextTick(() => {
	if (router.currentRoute.path === '/checkout') {
		if (store.state.user.promoCode && store.state.user.promoCode.discount_price) {
			if (total > store.state.user.promoCode.discount_price) {
				total -= store.state.user.promoCode.discount_price
				// Vue.toasted.show('Coupon Code Applied Successfully');
			} else {
				total = 0
				store.dispatch('siteData/setPaymentGatewayIdData', '')
				if (state[cartToUpdate].cartProducts.length > 0) {
					orderApi.orderCharge()
						.then((res) => {
							router.push({
								path: '/order-success',
								query: {
									order_number: store.getters['user/getOrderData'].order_number,
									payment_mode: 'card'
								}
							})
						})
				}
				// store.state.user.promoCode = '';
				// Vue.toasted.show('Cart Amount Should be Greater than Coupon Amount');
			}
		}
	}
	state[cartToUpdate].cartCount =
      productsInCart.length > 0 ? productsInCart.map(product => parseInt(product.quantity, 10)).reduce((prev, next) => prev + next) : 0
	state[cartToUpdate].cartTotal = total
	state[cartToUpdate].cartItemTotal = itemTotal
	state[cartToUpdate].cartTotalOffer = cartOffers
	store.state.order.amountToPay = total
	// })
}

const getters = {
	getOrderCart: (state) => {
		const orderCart = []
		state.mainCart.cartProducts.forEach((payload) => {
			const a = {}
			a.product_id = payload.product_id
			a.vendor_id = payload.vendor_id
			a.quantity = payload.quantity
			a.price = payload.price
			if (payload && payload.promotion_id) {
				a.promotion_id = payload.promotion_id
				a.price = payload.promotion_applied_price
			}
			a.name = payload.product_name
			orderCart.push(a)
		})
		return orderCart
	},
	getLocalCart: (state) => {
		const getCart = []
		state.localCart.cartProducts.forEach((payload) => {
			const a = {}
			a.productId = payload.productId
			a.vendorId = payload.vendorId
			a.quantity = payload.quantity
			getCart.push(a)
		})
		return getCart
	},
	getCartProducts: state => state.mainCart.cartProducts,
	getLocalCartProducts: state => state.localCart.cartProducts,
	getCartCount: state => state.mainCart.cartProducts.length,
	getcartTotal: state => state.mainCart.cartTotal,
	getcartItemTotal: state => state.mainCart.cartItemTotal,
	getcartTotalOffer: state => state.mainCart.cartTotalOffer,
	getConfirmedProducts: state => state.confirmedProducts,
	getCartTotalQuantity: state => state.mainCart.cartCount
}

const mutations = {
	mutateAddToCart: (state, payload) => {
		const products = state.mainCart.cartProducts.filter(
			cartProduct => (cartProduct.product_id === payload.product_id &&
        cartProduct.vendor_id === payload.vendor_id))
		const product = {}
		if (products.length === 0) {
			if (payload.vpi && payload.product_details) {
				product.timestamp = new Date().getTime()
				product.image_url = payload.product_details.image_URL_1
				product.price = payload.vendor_product_inventories[0].price
				product.quantity = payload.quantity
				product.product_id = payload.product_id
				product.product_name = payload.product_name
				if (payload && payload.promotion && payload.promotion.promotion_id) {
					product.promotion_id = payload.promotion.promotion_id
					product.promotion_applied_price = payload.promotion.promotion_applied_price
				}
				product.stock = payload.vpi.available_stock
				product.max_quantity = payload.vpi.max_quantity
				product.vendor_id = payload.vpi.vendor_id
				product.vendor_name = payload.vpi.vendor_name
				state.mainCart.cartProducts.push(product)
			} else {
				state.mainCart.cartProducts.push(payload)
			}
		} else {
			const qnty = parseInt(products[0].quantity, 10) + parseInt(payload.quantity, 10)
			const stock = products[0].stock
			const max = products[0].max_quantity

			if (stock <= max) {
				if (qnty <= stock) {
					products[0].quantity = qnty
				} else {
					Vue.toasted.show(
						`Sorry, You have already added ${
							products[0].quantity
						} item(s) in your cart, No more stock available now. `, {
							icon: 'exclamation-circle',
							position: 'bottom-right'
						}
					)
					products[0].quantity = stock
				}
			} else if (qnty <= max) {
				products[0].quantity = qnty
			} else {
				Vue.toasted.show(
					`Maximum order quantity per customer is limited to ${
						products[0].quantity
					} for this product.`, {
						icon: 'exclamation-circle',
						position: 'bottom-right'
					}
				)
				products[0].quantity = max
			}
			// products[0].quantity = products[0].quantity;
			products[0].timestamp = new Date().getTime()
		}
		updateCartproperties(state, 'mainCart')
	},
	mutateDeleteFromCart: (state, payload) => {
		const index = state.mainCart.cartProducts.findIndex(
			cartProducts => cartProducts.product_id === payload
		)
		state.mainCart.cartProducts.splice(index, 1)
		updateCartproperties(state, 'mainCart')
	},
	mutateUpdateCartQuantity: (state) => {
		sharedCartMethods.insertCartApiChooser()
		updateCartproperties(state, 'mainCart')
	},
	mutateEmptyCart: (state) => {
		state.localCart.cartProducts = state.mainCart.cartProducts
		state.mainCart.cartProducts = []
		updateCartproperties(state, 'mainCart')
	},
	mutateEmptyLocalCart: (state) => {
		state.localCart.cartProducts = []
	},
	mutateUpdateCart: (state, payload) => {
		state.mainCart.cartProducts = payload
		updateCartproperties(state, 'mainCart')
	},
	mutateSetConfirmedProducts: (state, payload) => {
		state.confirmedProducts = payload
	},
	mutateupdateGiftCardCartQuantity: (state) => {
		updateCartproperties(state, 'mainCart')
	},
	mutateupdateCartCoinAmount: (state) => {
		updateCartproperties(state, 'mainCart')
	}
}

const actions = {
	addToCart: ({
		commit
	}, payload) => {
		commit('mutateAddToCart', payload)
	},
	deleteFromCart: ({
		commit
	}, payload) => {
		commit('mutateDeleteFromCart', payload)
	},
	updateCartQuantity: ({
		commit
	}) => {
		commit('mutateUpdateCartQuantity')
	},
	emptyCart: ({
		commit
	}) => {
		commit('mutateEmptyCart')
	},
	emptyLocalCart: ({
		commit
	}) => {
		commit('mutateEmptyLocalCart')
	},
	updateCart: ({
		commit
	},
	payload) => {
		commit('mutateUpdateCart', payload)
	},
	setConfirmedProducts: ({
		commit
	}, payload) => {
		commit('mutateSetConfirmedProducts', payload)
	},
	updateGiftCardCartQuantity: ({
		commit
	}) => {
		commit('mutateupdateGiftCardCartQuantity')
	},
	updateCartCoinAmount: ({
		commit
	}) => {
		commit('mutateupdateCartCoinAmount')
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}
